import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const ContextMenu = () => {
  const [contextMenu, setContextMenu] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC CONTEXT MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Context Menus</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Context Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center text-slate-500 text-sm cursor-context-menu">
              Right click to see menu
              <div className="absolute hidden bg-slate-800 border border-slate-600 rounded shadow-lg py-1 min-w-32">
                <div className="px-4 py-2 hover:bg-slate-700 text-sm text-slate-300 cursor-pointer">Edit</div>
                <div className="px-4 py-2 hover:bg-slate-700 text-sm text-slate-300 cursor-pointer">Copy</div>
                <div className="px-4 py-2 hover:bg-slate-700 text-sm text-slate-300 cursor-pointer">Delete</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div onContextMenu={(e) => {e.preventDefault(); setShowMenu(true);}}>
  <div className="bg-slate-800 border rounded shadow-lg">
    <div className="px-4 py-2 hover:bg-slate-700 cursor-pointer">Edit</div>
    <div className="px-4 py-2 hover:bg-slate-700 cursor-pointer">Copy</div>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Context Menu with Icons</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center text-slate-500 text-sm">
              Right click preview area
              <div className="absolute hidden bg-slate-800 border border-slate-600 rounded shadow-lg py-1">
                <div className="px-4 py-2 hover:bg-slate-700 flex items-center gap-2 text-sm text-slate-300">
                  <span></span> Edit
                </div>
                <div className="px-4 py-2 hover:bg-slate-700 flex items-center gap-2 text-sm text-slate-300">
                  <span></span> Copy
                </div>
                <div className="border-t border-slate-600 my-1"></div>
                <div className="px-4 py-2 hover:bg-red-900 flex items-center gap-2 text-sm text-red-300">
                  <span></span> Delete
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-800 rounded shadow-lg py-1">
  <div className="px-4 py-2 flex items-center gap-2 hover:bg-slate-700">
    <span></span> Edit
  </div>
  <div className="border-t border-slate-600"></div>
  <div className="px-4 py-2 text-red-300">Delete</div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Grouped Context Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-40 flex items-center justify-center text-slate-500 text-sm">
              Right click to see grouped menu
              <div className="absolute hidden bg-slate-800 border border-slate-600 rounded shadow-lg py-1 min-w-40">
                <div className="text-xs text-slate-500 px-4 py-2 font-semibold">EDIT</div>
                <div className="px-4 py-1.5 hover:bg-slate-700 text-sm text-slate-300">Cut</div>
                <div className="px-4 py-1.5 hover:bg-slate-700 text-sm text-slate-300">Copy</div>
                <div className="text-xs text-slate-500 px-4 py-2 font-semibold mt-1">VIEW</div>
                <div className="px-4 py-1.5 hover:bg-slate-700 text-sm text-slate-300">Zoom In</div>
                <div className="px-4 py-1.5 hover:bg-slate-700 text-sm text-slate-300">Zoom Out</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-800 rounded shadow-lg py-1">
  <div className="text-xs text-slate-500 px-4 py-2 font-semibold">EDIT</div>
  <div className="px-4 py-1.5 hover:bg-slate-700">Cut</div>
  <div className="text-xs text-slate-500 px-4 py-2 font-semibold">VIEW</div>
  <div className="px-4 py-1.5 hover:bg-slate-700">Zoom</div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Disabled Items</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center text-slate-500 text-sm">
              See disabled states
              <div className="absolute hidden bg-slate-800 border border-slate-600 rounded shadow-lg py-1">
                <div className="px-4 py-2 hover:bg-slate-700 text-sm text-slate-300">Available</div>
                <div className="px-4 py-2 text-slate-600 cursor-not-allowed text-sm">Disabled Option</div>
                <div className="px-4 py-2 hover:bg-slate-700 text-sm text-slate-300">Another</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-800 rounded shadow-lg">
  <div className="px-4 py-2 hover:bg-slate-700">Active</div>
  <div className="px-4 py-2 text-slate-600 cursor-not-allowed">Disabled</div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED CONTEXT MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Context Menu</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="absolute hidden bg-slate-800 border border-amber-600 border-2 rounded shadow-lg py-1">
                <div className="px-4 py-2 hover:bg-amber-900 text-sm text-amber-300">Amber Action</div>
                <div className="px-4 py-2 hover:bg-amber-900 text-sm text-amber-300">Another</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-800 border border-amber-600 border-2">
  <div className="px-4 py-2 hover:bg-amber-900 text-amber-300">Action</div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContextMenu;


